export default __webpack_public_path__ + "static/international-transfer-0447d6c08c4b0391908ec54e180659a1.png";